/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as Types from '../../graph/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveEappMutationVariables = Types.Exact<{
  input: Types.SaveDpidDataRequest;
}>;


export type SaveEappMutation = { __typename?: 'Mutation', saveEapp: boolean };


export const SaveEappDocument = gql`
    mutation SaveEapp($input: SaveDpidDataRequest!) {
  saveEapp(input: $input)
}
    `;
export type SaveEappMutationFn = Apollo.MutationFunction<SaveEappMutation, SaveEappMutationVariables>;

/**
 * __useSaveEappMutation__
 *
 * To run a mutation, you first call `useSaveEappMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEappMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEappMutation, { data, loading, error }] = useSaveEappMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEappMutation(baseOptions?: Apollo.MutationHookOptions<SaveEappMutation, SaveEappMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEappMutation, SaveEappMutationVariables>(SaveEappDocument, options);
      }
export type SaveEappMutationHookResult = ReturnType<typeof useSaveEappMutation>;
export type SaveEappMutationResult = Apollo.MutationResult<SaveEappMutation>;
export type SaveEappMutationOptions = Apollo.BaseMutationOptions<SaveEappMutation, SaveEappMutationVariables>;